import {
    Button,
    CircularProgress,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    SnackbarContent,
    TextField,
    Typography
} from "@mui/material";
import amber from "@mui/material/colors/amber";
import green from "@mui/material/colors/green";
import { withStyles } from "@mui/styles";
import axios from "axios";
import * as React from "react";
import { Config } from "../../config/config";
import { Helpers } from "../../utils/helpers";
import { PopupMessage } from "../../utils/message";

interface NewBundleSate {
    modalVisible: boolean;
    isLoaded: boolean;
    creatingChest: boolean;
    error: null | string;
    form: any;
}

interface NewBundleProps {
    buttonText?: string;
    refreshParent(): void;
    classes: any;
}

class NewPackWrapped extends React.Component<NewBundleProps, NewBundleSate> {

    constructor(props) {
        super(props);
        // List with grid items
        this.state = {
            // Flags
            modalVisible: false,
            isLoaded: false,
            error: null,
            creatingChest: false,
            // Form data
            form: {
                pack_name: "",
            },
        };
    }

    showModal = () => this.setState({ modalVisible: true });
    handleModalCancel = () => this.setState({ modalVisible: false, error: null, form: {} });
    handleModalCreate = () => {
        this.setState({ creatingChest: true }, async () => {
            try {
                const result = await axios.post(`${Config.getInstance.apiUrl}/api/bounty/packs`, {
                    ...this.state.form,
                }, {

                    headers: {
                        Authorization: Helpers.getSessionId(),
                    },
                });

                this.setState({ creatingChest: false, modalVisible: false, form: {} }, () => {
                    this.props.refreshParent();
                });
            } catch (error) {
                PopupMessage.error("Something went wrong");

                this.setState({ creatingChest: false });
            }
        });
    }

    handleChange = name => event => {
        const formData = { ...this.state.form };
        formData[name] = event.target.value;

        if (name === "currency" && event.target.value === 9) {
            formData.price = 0;
        }

        this.setState({ form: formData });
    }

    render() {
        const { classes } = this.props;

        return (
            <div>
                <Button disableElevation color="primary" onClick={this.showModal} variant="contained" size="small">
                    {this.props.buttonText}
                </Button>

                <Dialog
                    open={this.state.modalVisible}
                    onClose={this.handleModalCancel}
                    aria-labelledby="form-dialog-title"
                    fullWidth={true}
                    maxWidth="sm"
                >
                    <DialogTitle id="form-dialog-title">
                        Create bounty pack
                    </DialogTitle>
                    <DialogContent>
                        <SnackbarContent
                            className="warning-banner"
                            aria-describedby="client-snackbar"
                            message={
                                <span id="client-snackbar" className={classes.message}>
                                    Don't forget to export Google Sheet after creating new bounty pack.
                                </span>
                            }
                        />

                        <TextField
                            margin="normal"
                            id="pack_name"
                            label="Bounty pack name"
                            fullWidth
                            onChange={this.handleChange("pack_name")}
                            value={this.state.form.pack_name || ""}
                        />

                        <Typography variant="h6" style={{ marginBottom: 0, marginTop: 15, color: "#919191" }}>
                            Localization
                        </Typography>

                        <TextField
                            margin="normal"
                            id="localization_title"
                            label="Title"
                            fullWidth
                            onChange={this.handleChange("localization_title")}
                            value={this.state.form.localization_title || ""}
                        />

                        <TextField
                            margin="normal"
                            id="localization_desc"
                            label="Description"
                            fullWidth
                            onChange={this.handleChange("localization_desc")}
                            value={this.state.form.localization_desc || ""}
                        />
                    </DialogContent>
                    <DialogActions>
                        <Button disableElevation onClick={this.handleModalCancel} disabled={this.state.creatingChest} size="small" variant="outlined">
                            Cancel
                        </Button>
                        <div className={classes.wrapper}>
                            <Button disableElevation
                                onClick={this.handleModalCreate}
                                color="primary"
                                disabled={this.state.creatingChest}
                                size="small"
                                variant="contained"
                            >
                                Create
                            </Button>
                            {this.state.creatingChest && <CircularProgress size={24} className={classes.buttonProgress} />}
                        </div>
                    </DialogActions>
                </Dialog>
            </div>
        );
    }
}

const styles: any = theme => ({
    wrapper: {
        margin: 8,
        position: "relative",
    },
    buttonProgress: {
        color: green[500],
        position: "absolute",
        top: "50%",
        left: "50%",
        marginTop: -12,
        marginLeft: -12,
    },
    message: {
        display: "flex",
        alignItems: "center",
    },
});

export const NewPack = withStyles(styles)(NewPackWrapped);
